import Vue from 'vue';
import template from './template.html';
import $ from 'jquery';
import _ from 'lodash';

import Modal from '../modal/main';


window.$ = $;

export default Vue.component('videos', {
  template: template,
  data: function () {
    return {
      progress: 0,
      duration: 0,
      currentVideo: {},
      currentTime: 0,
      modalTime: 0,
      noPrompt: false,
      showModal: false,
      barWidth: 0,
      videoDuration: 0,
      videoPlaying: false,
      videoEnded: false,
      video: false,
      ytPlayer: undefined,
      windowWidth: window.outerWidth,
      otherVideos: [],
      hintPoint: false
    };
  },
  watch: {
    videos (videos) {
      if(videos && videos.length) {
        this.updateCurrentVideo();
      }
    },
    videoId (current) {
      if(current) {
        let $vm = this;
        setTimeout(function () {
          $vm.otherVideos = $vm.getOtherVideos();
        }, 3000);
      }
    },
    hasPreloaded () {
      if(this.hasPreloaded) {
        this.init();
      }
    },
    currentTime (current) {
      let match = false;
      this.modalTimes.forEach(function (time) {
        if(current >= time && current < time + 10) {
          match = true;
        }
      });
      this.hintPoint = match;
    },
    '$route' (to, from) {
      if(to.name.match('videos')){
        if(from.params.id != to.params.id) {
          this.updateCurrentVideo();
        } else if(to.params.time) {
          this.showModalAt(to.params.time * 1);
        }
      } else {
        this.showModal = false;
      }
    }
  },
  components: {Modal},
  mounted () {
    let $vm = this;
    let iframe = this.$el.getElementsByTagName('iframe')[0];
    this.iframe = iframe;
    this.barWidth = $('.videos__progress').prop('offsetWidth');
    this.otherVideos = $vm.getOtherVideos();
    this.updateCurrentVideo();

    if(this.prevRoute) {
      this.init();
    }

  },
  methods: {
    init () {
      let $vm = this;
      if(_.isObject(window.YT) && _.isObject(window.YT.Player)) {
        let ytPlayer = new window.YT.Player(this.iframe, {
          events: {
            'onReady': function () {
              $vm.playerSetup(ytPlayer);
            }
          }
        });

        $('.videos__playpause').on('mousemove', _.debounce(function () {
          $vm.peekUI();
        }, 50));

        $('.videos__playpause').on('click', function () {
          $vm.togglePlayPause();
        });
      } else {
        setTimeout(this.init, 1000);
      }
    },
    playerSetup (ytPlayer) {
      let $vm = this;
      this.ytPlayer = ytPlayer;
      this.currentVideo.duration = ytPlayer.getDuration();
      if(this.$route.params.time) {
        this.showModalAt(this.$route.params.time * 1);
        this.currentVideo.furthestTime = this.$route.params.time * 1;
      } else {
        if($vm.currentVideo.seenPrompt) {
          $vm.handlePlay();
        } else {
          setTimeout(function () {
            $vm.handlePlay();
          }, 3000);
        }
      }

      this.monitorPlayerStateChange();
    },
    monitorPlayerStateChange () {
      let $vm = this;
      let timer = setInterval(function () {
        if($vm.ytPlayer) {
          let state = $vm.ytPlayer.getPlayerState();
          if(state == 1) { // playing state
            $vm.updateTime();
            $vm.videoEnded = false;
            $vm.videoPlaying = true;
            if($vm.isTouchDevice && $vm.showNav) {
              $vm.showModal = false;
              // $vm.$store.dispatch('hideNav');
            }
          }
          else if(state == 2) { // paused state
            $vm.videoPlaying = false;
            $vm.$store.dispatch('showNav');
          }
          else if(state == 0) { // paused state
            $vm.videoPlaying = false;
            $vm.videoEnded = true;
            $vm.$store.dispatch('showNav');
          }
        }

        if(!$vm.$route.name.match('videos')) {
          window.clearInterval(timer);
        }

      }, 1000);

    },
    updateTime () {
      let ytPlayer = this.ytPlayer;
      let currentTime = ytPlayer.getCurrentTime();
      let currentVideo = this.currentVideo || {};
      this.currentTime = currentTime;
      currentVideo.furthestTime = Math.max(currentTime, currentVideo.furthestTime || 0);
    },
    updateCurrentVideo () {
      if(this.videos && this.videos.length) {
        this.currentVideo =  _.find(this.videos, {id: this.$route.params.id * 1});
        this.introPrompt();
      }
    },
    // this video info modal was added last minite, logic could be better placed
    // but its the 11th hour. しょうがない
    introPrompt () {
      let $vm = this;
      if(!this.$route.params.time) {
        if(!$vm.currentVideo.seenPrompt) {
          // $vm.$store.dispatch('hideNav');
          setTimeout(function () {
            $vm.currentVideo.seenPrompt = true;
          }, 6000);
        }
      } else {
        $vm.noPrompt = true;
      }
    },
    peekUI () {
      let $vm = this;
      if(!this.showNav && this.videoPlaying) {
        this.$store.dispatch('showNav');
        window.clearTimeout(this.peekingTimer);
        this.peekingTimer = setTimeout(function () {
          if($vm.videoPlaying) {
            $vm.handleHideNav();
          }
        }, 3000);
      }
    },
    togglePlayPause () {
      let state = this.ytPlayer.getPlayerState();
      if(state == 1) {
        this.ytPlayer.pauseVideo();
      } else {
        // this.ytPlayer.playVideo();
        this.showModal = false;
        this.handlePlay();
      }
    },
    closeModal () {
      this.showModal = false;
      // this.ytPlayer.playVideo();
      this.handlePlay();
    },
    openModal (pin, hotspot) {
      // this.showModal = true;
      // this.modalTime = pin.section.time;
      // this.currentTime = pin.section.time;

      if(hotspot) {
        this.showHotspotModal(pin.section.time);
        this.trackModal(pin, '-hotspot');

      } else {
        this.showModalAt(pin.section.time);
        this.trackModal(pin, '-timeline');

      }
    },
    showHotspotModal (time) {
      this.ytPlayer.pauseVideo();
      this.showModal = true;
      this.modalTime = time;
      this.currentTime = time;
      this.$router.push({
        name: 'videos',
        params: {
          id:this.$route.params.id,
          time: time
        }
      });
    },
    showModalAt (time) {
      let $vm = this;
      $vm.ytPlayer.seekTo(time, true);
      $vm.modalTime = time;
      $vm.currentTime = time;
      $vm.showModal = true;
      $vm.$store.dispatch('showNav');

      if(!this.isTouchDevice) {
        $vm.ytPlayer.playVideo();
        setTimeout(function () {
          $vm.ytPlayer.pauseVideo();
        }, 1300);
      } else {
        this.ytPlayer.pauseVideo();
      }

      this.$router.push({
        name: 'videos',
        params: {
          id:this.$route.params.id,
          time: time
        }
      });

    },
    timePercentage (time) {
      return Math.floor((time / this.currentVideo.duration) * 100);
    },
    timeToOffset (time) {
      let xpos = -100;
      if(this.ytPlayer) {
        xpos = this.timePercentage(time);
      }
      return xpos + '%';
    },
    scrobble (evt) {
      let parentWidth = $('.videos__progress').prop('offsetWidth');
      let xpos = evt.offsetX;
      let time = Math.floor((xpos / parentWidth) * this.currentVideo.duration);
      this.ytPlayer.seekTo(time, true);
    },
    handlePlay () {
      let $vm = this;
      // let isTouch = this.isTouchDevice;
      if(!this.isTouchDevice || this.windowWidth > 1020) {
        this.ytPlayer.playVideo();
        setTimeout(function () {
          $vm.handleHideNav();
        }, 5000);
      }
    },
    handleHideNav () {
      if(this.$route.name.match('videos') && !this.showModal) {
        this.$store.dispatch('hideNav');
      }
    },
    replayVideo () {
      this.ytPlayer.seekTo(1, true);
      this.$router.push(`/videos/${this.currentVideo.id}`);
      this.handlePlay();
    },
    getOtherVideos () {
      let $vm = this;
      return _.filter(this.videos, function (video) { return video.id !== $vm.currentVideo.id;});
    },
    trackModal (pin, type) {
      if(pin.title) {
        window.dataLayer.push({
          'event': `videoNav${type}`,
          'name': pin.title,
          'category': pin.category,
          'videoId': pin.section.video,
          'videoTitle': this.currentVideo.title,
          'videoTimePoint': pin.section.time
        });
      }
    }
  },
  computed: {
    prevRoute () {
      return this.$store.state.routes.prevRoute.name;
    },
    videos () {
      return this.$store.state.content.videos;
    },
    details () {
      return this.$store.state.content.details || [];
    },
    // currentVideo () {
    //   return this.videos ? _.find(this.videos, {id: this.$route.params.id * 1}) : {};
    // },
    videoId () {
      return this.currentVideo ? this.currentVideo.ytID : '';
    },
    videoURL () {
      let base = 'https://www.youtube.com/embed/';
      let end = '?enablejsapi=1&playsinline=1&controls=0&showinfo=0&modestbranding=1&fs=0';
      let vid = this.videoId;
      return base + vid + end;
    },
    showNav () {
      return this.$store.state.ui.showNav;
    },
    hasPreloaded () {
      return this.$store.state.ui.hasPreloaded;
    },
    isTouchDevice () {
      return this.$store.state.ui.isTouchDevice;
    },
    progressBar () {
      return this.timeToOffset(this.currentTime);
    },
    modals () {
      let $vm = this;
      // return _.filter($vm.details, {section: {video: $vm.$route.params.id * 1}})
      return _.chain($vm.details).filter({section: {video: $vm.$route.params.id * 1}}).orderBy('section.time').value();
    },
    modalTimes () {
      return this.modals ? _.map(this.modals, modal => modal.section.time) : [];
    }
  }
});



// WEBPACK FOOTER //
// ./C:/projects/okinawa/be-okinawa/src/js/components/videos/main.js